import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
export function Guarantee() {
  return <section className="bg-white px-4 py-6 border-b border-brand-line" data-id="element-78" data-mp="1o33tsfx1zqh8">
      <div className="max-w-3xl mx-auto" data-id="element-79" data-mp="223oexiqfxydw">
        <div className="bg-brand-cream border-2 border-brand-green rounded-2xl p-4 sm:p-5 text-center" data-id="element-80" data-mp="221byxb48ty3h">
          <div className="w-11 h-11 mx-auto bg-brand-green/15 rounded-full flex items-center justify-center mb-1.5" data-id="element-81" data-mp="1x28pzfl577q8">
            <ShieldCheckIcon className="w-6 h-6 text-brand-green" aria-hidden="true" data-id="element-82" data-mp="14fo3otjixltj" />
          </div>
          <h2 className="font-display text-xl sm:text-2xl text-brand-navy mb-2" data-id="element-83" data-mp="1j5ls9ald8dj9">
            Your purchase is 100% protected
          </h2>
          <div className="text-sm sm:text-base text-brand-slate font-medium leading-snug max-w-2xl mx-auto space-y-1.5" data-id="element-84" data-mp="1ebr5tzedlkgh">
            <p data-id="element-85" data-mp="lpg2igzdx5fz">Explore {PRODUCT_NAME} for 14 days.</p>
            <p data-id="element-86" data-mp="lon3612r9i7v">
              Review the six modules, ready-to-teach lessons, activity library,
              skill progressions, management tools, assessment resources and
              five bonuses.
            </p>
            <p data-id="element-87" data-mp="twi2itoa11j4">
              If the system isn't right for you, contact us within 14 days for a
              full refund according to the refund terms.
            </p>
          </div>
        </div>
      </div>
    </section>;
}